module.exports = __webpack_public_path__ + "img/product-laptop.c588bcb8.jpg";